import { FadeIn, ChapterHeading } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const WhyKrug = () => {
  const { t } = useLang();
  const WHY_ITEMS = t.why.items;
  return (
  <section data-testid="why-krug-section" className="relative bg-krug-mist py-24 md:py-32 overflow-hidden">
    <img
      src="/assets/krug-logo.png"
      alt=""
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[620px] md:w-[860px] opacity-[0.08] animate-spin-slower pointer-events-none select-none"
    />
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <ChapterHeading number="08" eyebrow={t.why.eyebrow} title={t.why.title} align="center" dark={false} />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY_ITEMS.map((item, i) => (
          <FadeIn key={item.title} delay={i * 0.09}>
            <article data-testid={`why-item-${i}`} className="h-full rounded-3xl border border-krug-navy/10 bg-white p-8 text-center shadow-[0_24px_60px_-34px_rgba(10,21,38,0.3)] hover:border-krug-teal/60 transition-colors duration-500">
              <span className="mx-auto inline-flex items-center justify-center w-13 h-13 p-3.5 rounded-full bg-krug-teal/15 text-krug-teal">
                <item.icon size={24} />
              </span>
              <h3 className="mt-5 font-heading text-xl font-extrabold text-krug-navy">{item.title}</h3>
              <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{item.copy}</p>
            </article>
          </FadeIn>
        ))}
      </div>
      <FadeIn delay={0.3}>
        <p data-testid="why-krug-note" className="mt-14 text-center font-heading text-lg md:text-xl font-bold text-slate-500">
          {t.why.noteA}<span className="text-gradient-gold">{t.why.noteB}</span>
        </p>
      </FadeIn>
    </div>
  </section>
  );
};
